import { RepositoryFactory } from '@/repositories/RepositoryFactory'
import { convertPrice } from '@/utils/common'
import { formatDate } from '@/utils/date'
import _ from 'lodash'
import moment from 'moment'

const DebtRepository = RepositoryFactory.get('debts')
const InstallmentRepository = RepositoryFactory.get('installments')
const StoreRepository = RepositoryFactory.get('stores')

/**
 * DebtInstallmentWarrantyService - Business logic for debt installment warranty (trả góp bảo hành)
 */
export default {
  async getInstallmentWarrantyTransactions(params = {}) {
    try {
      const response = await DebtRepository.getInstallmentWarrantyTransactions(params)
      return this.formatResponseData(response)
    } catch (error) {
      console.error(
        'Error in DebtInstallmentWarrantyService.getInstallmentWarrantyTransactions:',
        error,
      )
      throw error
    }
  },

  async getInstallmentsForAutocomplete() {
    try {
      const installments = await InstallmentRepository.getForAutocomplete()
      return [
        { value: null, text: 'Tất cả dịch vụ trả góp' },
        ...installments.map((item) => ({ value: item.id, text: item.name })),
      ]
    } catch (error) {
      console.error('Error getInstallmentsForAutocomplete:', error)
      throw error
    }
  },

  async getStoresForAutocomplete() {
    try {
      return await StoreRepository.getForAutocomplete()
    } catch (error) {
      console.error('Error getStoresForAutocomplete:', error)
      throw error
    }
  },

  async loadInitialData() {
    try {
      const [installments, stores] = await Promise.all([
        this.getInstallmentsForAutocomplete(),
        this.getStoresForAutocomplete(),
      ])
      return { installments, stores }
    } catch (error) {
      console.error('Error loadInitialData:', error)
      throw error
    }
  },

  formatResponseData(rawData) {
    return {
      dataset: rawData.dataset || [],
      total: rawData.total || 0,
      pages: rawData.pages || 1,
    }
  },

  calculateTotalAmount(dataset, field) {
    const total = _.sumBy(dataset, (row) => row[field] || 0)
    return convertPrice(total)
  },

  calculateSummaryTotals(dataset) {
    return {
      totalPaymentAmount: this.calculateTotalAmount(dataset, 'sumAmountPayments'),
      totalPaidAmount: this.calculateTotalAmount(dataset, 'sumAmountTransactions'),
      totalRemainingAmount: this.calculateTotalAmount(dataset, 'sumRemainTransaction'),
      totalBillAmount: this.calculateTotalAmount(dataset, 'totalAmount'),
    }
  },

  isShowRow(payments, currentItem) {
    return _.findIndex(payments, ['id', currentItem.id]) === 0
  },

  generatePaymentNote(warranty, item) {
    let note = `Nhận thanh toán từ trả góp bảo hành\n`
    note += `ID BH: ${warranty.id}\n`
    note += `Mã phiếu BH: ${warranty.code}\n`
    note += `Dịch vụ: ${item.paymentName}\n`
    note += `Mã hợp đồng: ${item.paymentCode || ''}`
    return note
  },

  buildApiParameters(filters, route) {
    const page = route?.query?.page || 1
    return {
      page: parseInt(page, 10),
      pageSize: 10,
      storeId: filters.storeId || null,
      contactId: filters.contactId || null,
      fromDate: filters.fromDate
        ? moment(filters.fromDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
        : null,
      toDate: filters.toDate ? moment(filters.toDate, 'DD/MM/YYYY').format('DD/MM/YYYY') : null,
      contractCode: filters.contractCode || null,
      docId: filters.docId || null,
      customerMobile: filters.customerMobile || null,
      isFullPaid: filters.isFullPaid || null,
    }
  },

  validateFilters(filters) {
    const errors = []
    if (filters.fromDate && filters.toDate) {
      const fromDate = moment(filters.fromDate, 'DD/MM/YYYY')
      const toDate = moment(filters.toDate, 'DD/MM/YYYY')
      if (fromDate.isAfter(toDate)) {
        errors.push('Ngày bắt đầu không thể sau ngày kết thúc')
      }
    }
    return { isValid: errors.length === 0, errors }
  },

  formatDisplayDate(dateString) {
    return formatDate(dateString)
  },

  formatCurrency(amount) {
    return convertPrice(amount)
  },
}
